import React, { useRef, memo } from 'react'
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'
import { withTranslation, useTranslation } from 'react-i18next'
import { useTheme } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'
import { useSelector } from 'react-redux'
import useStyles from './formDetailsStyle'
import Typography from '../../atoms/display/typography'
import Tooltip from '../../atoms/display/tooltip'

import { GetApp as DownloadIcon } from '@material-ui/icons'

const renderKeyValue = (key, value, index, styleOptions) => (
  <div
    key={key + value + index}
    className={styleOptions.classes.formContent}
  >
    <Typography
      className={styleOptions.classes.labelFormProperty}
      style={{ color: styleOptions.theme.palette.type !== 'dark' && 'white' }}
    >
      {key} :{' '}
    </Typography>
    <Typography className={styleOptions.classes.labelFormValue}>
      <span className="escapeDragScroll" style={{ cursor: 'text' }}>
        {value}
      </span>
    </Typography>
  </div>
)

const renderFormChildren = (history, objectZero, styleOptions) => {
  return objectZero.children.map((objectOne, indexOne) => (
    <div key={indexOne}>
      {objectOne?.hasOwnProperty('children') ? (
        <div>
          <h2
            className={styleOptions.classes.secundary}
            style={{
              color:
                styleOptions.theme.palette.type == 'dark' ? 'white' : '#182444',
            }}
          >
            {objectOne?.name}
          </h2>
          {objectOne?.children?.map((objectTwo, indexTwo) => (
            <div key={indexOne + indexTwo}>
              {objectTwo?.hasOwnProperty('children') ? (
                <div className={styleOptions.classes.formDataPlaceholder}>
                  <h2
                    className={styleOptions.classes.secundary}
                    style={{
                      color: 'white',
                    }}
                  >
                    {objectTwo?.name}
                  </h2>
                  {objectTwo?.children.map((objectThree, indexThree) => (
                    <div key={indexOne + indexTwo + indexThree}>
                      {renderKeyValue(
                        objectThree.name,
                        objectThree.value,
                        indexThree,
                        styleOptions
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div
                  key={indexOne + indexTwo}
                  className={styleOptions.classes.formDataPlaceholder}
                >
                  {renderKeyValue(
                    objectTwo.name,
                    objectTwo.value,
                    indexTwo,
                    styleOptions
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div
          key={indexOne}
          className={styleOptions.classes.formDataPlaceholder}
        >
          {renderKeyValue(
            objectOne.name,
            objectOne.value,
            indexOne,
            styleOptions
          )}
        </div>
      )}
    </div>
  ))
}

const renderForm = (history, styleOptions) => {
  const printRef = useRef()

  const handleDownloadPdf = async () => {
    const element = printRef.current
    const canvas = await html2canvas(element, {
      scale: 2,
    })
    let imgData = canvas.toDataURL('image/png', 1.0)
    let doc = new jsPDF('', 'mm', [canvas.width, canvas.height])
    doc.addImage(imgData, 'png', 0, 0, canvas.width / 4, canvas.height / 4)
    doc.save('formData.pdf')
  }
  const { t } = useTranslation()

  return (
    <>
      <Tooltip title={t('commons.downloadAsPdf')} placement="auto">
        <div
          style={{
            marginTop: styleOptions.small ? '0em' : '1em',
            background:
              styleOptions.theme.palette.type === 'dark' ? '#fff' : '#182444',
            color:
              styleOptions.theme.palette.type === 'dark' ? '#182444' : '#fff',
          }}
          className={styleOptions.classes.downloadButton}
          onClick={handleDownloadPdf}
        >
          <DownloadIcon></DownloadIcon>
        </div>
      </Tooltip>
      <div ref={printRef}>
        {history &&
          history?.map((objectZero, index) => {
            return (
              <>
                {objectZero?.hasOwnProperty('children') ? (
                  <div key={index}>
                    <h1
                      className={styleOptions.classes.title}
                      style={{
                        color:
                          styleOptions.theme.palette.type == 'dark'
                            ? 'white'
                            : '#182444',
                      }}
                    >
                      {objectZero?.name}
                    </h1>
                    {renderFormChildren(history, objectZero, styleOptions)}
                  </div>
                ) : (
                  <div
                    key={index}
                    className={styleOptions.classes.formDataPlaceholder}
                    ref={printRef}
                  >
                    {renderKeyValue(
                      objectZero?.name,
                      objectZero?.value,
                      index,
                      styleOptions
                    )}
                  </div>
                )}
              </>
            )
          })}
      </div>
    </>
  )
}

const RenderFormData = ({ history = false, small = false }) => {
  const size = useSelector((state) => state.preferences)
  let useStylesParams = {
    size: size,
  }
  const classes = useStyles(useStylesParams)
  const theme = useTheme()

  let styleOptions = { small: small, classes: classes, theme: theme }
  return (
    <Box style={{ width: '100%' }}>
      <div>{renderForm(history, styleOptions)}</div>
    </Box>
  )
}

export default withTranslation()(memo(RenderFormData))
